export const filterHasValue = (values) => (filter) => {
    const value = values === null || values === void 0 ? void 0 : values[filter.id];
    if (!value) {
        return false;
    }
    if (Array.isArray(value) && value.length === 0) {
        return false;
    }
    if (typeof value === 'string' && value.trim() === '') {
        return false;
    }
    return true;
};
//# sourceMappingURL=index.js.map